import { ArticleHeading2, ArticleHeading4, TDeviceType, UIText1 } from '@cian/ui-kit';
import { clsx as cn } from 'clsx';
import * as React from 'react';

import * as styles from './EarnWithCian.css';
import arrow from './assets/arrow.svg';
import centerCoin from './assets/centerCoin.png';
import { TYPOGRAPHY } from './constans';

interface IEarnWithCianProps {
  deviceType: TDeviceType;
  action: JSX.Element;
  onVideoModalOpen: () => void;
}

export const EarnWithCian: React.FC<IEarnWithCianProps> = ({ deviceType, action, onVideoModalOpen }) => {
  const AdaptiveHeading = deviceType === 'phone' ? ArticleHeading4 : ArticleHeading2;

  return (
    <div className={cn(styles['wrapper'], styles[`wrapper-${deviceType}`])}>
      <div className={cn(styles['container'], styles[`container-${deviceType}`])}>
        <div className={cn(styles['text-container'], styles[`text-container-${deviceType}`])}>
          <div className={styles['title-container']}>
            <h1 className={cn(styles['title'], styles[`title-${deviceType}`])}>{TYPOGRAPHY.TITLE}</h1>
          </div>
          <div className={styles['subtitle-container']}>
            <AdaptiveHeading color="white_100" fontWeight={deviceType === 'phone' ? 'normal' : 'bold'}>
              {TYPOGRAPHY.SUBTITLE}
            </AdaptiveHeading>
          </div>
        </div>
        <div className={cn(styles['arrow-container'], styles[`arrow-container-${deviceType}`])}>
          <div className={styles['action']}>{action}</div>
          <img src={arrow} alt="arrow" className={styles['arrow-image']} />
          <img src={centerCoin} alt="coin" className={styles['coin-image']} />
        </div>
        <div className={cn(styles['video-button-container'], styles[`video-button-container-${deviceType}`])}>
          <div className={styles['button-container']}>
            <button
              onClick={onVideoModalOpen}
              type="button"
              className={styles['video-button']}
              data-testid="video-button"
            />
            <span className={styles['video-play-icon']}></span>
          </div>
          <UIText1 color="current_color">
            Рассказываем, как работает <br /> сервис — 2 минуты
          </UIText1>
        </div>
      </div>
    </div>
  );
};
